/**
 * Detect env.example-style placeholders that were copied into Coolify/CI by mistake.
 * Truthy strings like `your_recaptcha_site_key` must not be treated as configured secrets.
 */
export function isExplicitPlaceholderEnvValue(value: string | null | undefined): boolean {
  if (value == null) {
    return false;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  return /^(your_|change_me|placeholder|xxx+|todo\b|pk_live_or_pk_test_|sk_live_or_sk_test_)/i.test(
    trimmed,
  );
}

export function isPlaceholderEnvValue(value: string | null | undefined): boolean {
  if (value == null) {
    return true;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return true;
  }

  return isExplicitPlaceholderEnvValue(trimmed);
}

export function firstRealEnvValue(...candidates: Array<string | null | undefined>): string | null {
  for (const candidate of candidates) {
    if (candidate == null) {
      continue;
    }
    const trimmed = candidate.trim();
    if (!trimmed || isPlaceholderEnvValue(trimmed)) {
      continue;
    }
    return trimmed;
  }
  return null;
}
